import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import PaidSuccess from '../components/PaidSuccess';

const Result = (props) => {
  const urlParams = props.location && new URLSearchParams(props.location.search);
  const success = urlParams && urlParams.get('success');

  return (
    <>
      {
        success
          ? <PaidSuccess />
          : <h3>Failed: Payment has been failed</h3>
      }
    </>
  );
};

export default withRouter(connect(null, null)(Result));
